export default __webpack_public_path__ + "static/media/fullLogo.8c544ab1.png";